import Vue from 'vue'

const Components = [
    'rwText',
    'rwTexterae',
    'rwSwitch',
    'rwRadio',
    'rwCheckbox',
    'rwDropDownMenu',
    'rwPhone',
    'rwLinkage',
    // 'rwCascader',
    'rwUploadPictures',
    'rwMap',
    'rwSubmitButton',
    'rwScheduleBooking',
    'rwVerified',
    'rwBlankcontainer',
    'rwWords',
    'rwPicture',
    'rwbutton',
    'rwTitle',
    'rwCarouselmap',
    'rwPictureWindow',
    'rwIconGroup',
    'rwGroupMenu',
    'rwBtnMenu',
    'rwNotice',
    'rwVieo',
    'rwline',
    'rwRichText',
    'rwArticleList',
    'rwSearch',
    'rwVideoList',
    'rwLiveList',
    'rwProductList',
    'rwForm',
    'rwPay',
    'rwSchedule',
    'rwActive',
    'rwGroup',
    'rwMPerson',
    'rwCalendar',
    // 张强加的数据内容
    'rwSupplyInfoList',
    'rwSupplyList',
    'rwQuotes',
    'rwPromoteLive',
    'rwPurchaseInfoList',
    'rwPurchase',
    'rwActiveCenter',
    'rwSevice',
    'rwCompany',
    'rwSelectSeat',
    'rwCategoryInfoList'
]

Components.forEach(key => {
    Vue.component(key, () =>
        import (`@/custom-component/${key}`))
})


// WEBPACK FOOTER //
// ./src/custom-component/index.js